<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-75">
        <md-card>
          <md-card-header data-background-color="purple">
            <div class="md-layout md-alignment-center-space-between">
              <h4 class="title">Authentication/Authorization Transactions</h4>
              <div style="display: flex">
                <md-button class="md-icon-button md-dense refresh-btn" @click="refreshLogs(true)">
                  <md-tooltip md-direction="top">Download Logs</md-tooltip>
                  <md-icon>file_download</md-icon>
                </md-button>
                <search-box v-model="search" @doSearch="doSearch"></search-box>
                <md-button class="md-icon-button md-dense refresh-btn" @click="refreshLogs">
                  <md-tooltip md-direction="top">Refresh logs </md-tooltip>
                  <md-icon>refresh</md-icon>
                </md-button>
              </div>
            </div>

            <p v-if="totalLogs === 1" class="category">{{ totalLogs }} Transaction</p>
            <p v-else class="category">{{ totalLogs }} Transactions</p>
          </md-card-header>
          <md-card-content>
            <div>
              <md-table
                v-model="logins"
                :md-sort.sync="currentSort"
                :md-sort-order.sync="currentSortOrder"
                md-sort-fn="customSort"
                table-header-color="purple"
                class="md-table-narrow-cells"
                md-card
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Factor">{{ item.factor }} </md-table-cell>
                  <md-table-cell md-label="Result" class="text-center">
                    <i :class="item.status_flat">
                      <md-tooltip md-direction="top">{{ item.human_readable_status }} </md-tooltip>
                    </i>
                  </md-table-cell>
                  <md-table-cell class="text-breakable" md-label="Username">{{ item.username }} </md-table-cell>
                  <md-table-cell md-label="Application">{{ item.application_name }}</md-table-cell>
                  <md-table-cell md-label="Client IP">{{ item.ipAddress }}</md-table-cell>
                  <md-table-cell md-label="Dest. IP">{{ item.applicationIpAddress }}</md-table-cell>
                  <md-table-cell md-label="Date created" md-sort-by="date_created" class="text-breakable"
                    >{{ formatDate(item.date_created) }}
                    <md-tooltip>{{ getRelativeDate(item.date_created) }} </md-tooltip>
                  </md-table-cell>
                  <md-table-cell class="table-actions">
                    <md-button
                      class="md-icon-button"
                      @click="
                        selectedAuthTXForMoreInfoDialog = item.moreInfo;
                        showMoreInfoDialog = true;
                      "
                      :disabled="!item.moreInfo || Object.keys(item.moreInfo).length === 0"
                    >
                      <md-tooltip md-direction="top">More details</md-tooltip>
                      <md-icon>more_vert</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
            <div class="md-layout md-alignment-center">
              <pagination v-model="logsPagination" :page-count="totalPages" @input="changePage"></pagination>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
        <md-card>
          <md-card-header data-background-color="orange" class="md-layout">
            <h4 class="title filter-by">
              Filter By
              <md-button class="md-icon-button md-dense" @click="removeFilters('all')" v-if="removeAll">
                <md-icon>clear</md-icon>
              </md-button>
            </h4>
          </md-card-header>
          <md-card-content class="filters">
            <md-list>
              <div v-if="usernameSearched || appNameSearched">
                <md-subheader class="filter-radio">
                  Search
                  <md-button
                    class="md-icon-button md-dense"
                    @click="removeFilters('search')"
                    v-if="usernameSearched || appNameSearched"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </md-subheader>
                <md-radio v-if="this.appNameSearched" v-model="this.appNameSearched" :value="appNameSearched">
                  application_name : {{ appNameSearched }}
                </md-radio>
                <br v-if="this.appNameSearch" />
                <md-radio v-if="this.usernameSearched" v-model="this.usernameSearched" :value="usernameSearched">
                  username : {{ this.usernameSearched }}
                </md-radio>
              </div>
              <md-divider v-if="appNameSearched || usernameSearched"></md-divider>
              <div v-if="applicationUserRadio">
                <md-subheader class="filter-radio">
                  User
                  <md-button class="md-icon-button md-dense" @click="removeFilters('user')" v-if="applicationUserRadio">
                    <md-icon>clear</md-icon>
                  </md-button>
                </md-subheader>
                <md-radio v-model="applicationUserRadio" :value="username">{{ username }} </md-radio>
              </div>
              <md-divider v-if="applicationUserRadio"></md-divider>
              <div v-if="applicationNameRadio">
                <md-subheader class="filter-radio">
                  Application
                  <md-button
                    class="md-icon-button md-dense"
                    @click="removeFilters('application')"
                    v-if="applicationNameRadio"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </md-subheader>
                <md-radio v-model="applicationNameRadio" :value="applicationNameRadio"
                  >{{ applicationNameRadio }}
                </md-radio>
              </div>
              <div v-if="deviceIDRadio">
                <md-subheader class="filter-radio">
                  Device ID
                  <md-button class="md-icon-button md-dense" @click="removeFilters('deviceID')" v-if="deviceIDRadio">
                    <md-icon>clear</md-icon>
                  </md-button>
                </md-subheader>
                <md-radio v-model="deviceIDRadio" :value="deviceIDRadio">{{ deviceIDRadio }} </md-radio>
              </div>
              <md-divider v-if="deviceIDRadio"></md-divider>
              <md-subheader class="filter-radio">
                Date
                <md-button class="md-icon-button md-dense" @click="removeFilters('date')" v-if="dateRadio">
                  <md-icon>clear</md-icon>
                </md-button>
              </md-subheader>
              <md-radio v-model="dateRadio" value="day">Last Day</md-radio>
              <md-radio v-model="dateRadio" value="week">Last Week</md-radio>
              <md-radio v-model="dateRadio" value="month">Last Month</md-radio>

              <md-divider></md-divider>
              <md-subheader class="filter-radio"> Date Range </md-subheader>
              <div class="md-layout">
                <div style="margin-bottom: 10px">
                  <date-picker
                    v-model="dateSelectedGTE"
                    type="datetime"
                    value-type="format"
                    format="YYYY-MM-DD HH:mm"
                    placeholder="Start Date"
                    confirm="true"
                    @change="onDateGTEChange"
                  >
                  </date-picker>
                </div>
                <div style="margin-bottom: 10px">
                  <date-picker
                    v-model="dateSelectedLTE"
                    type="datetime"
                    value-type="format"
                    format="YYYY-MM-DD HH:mm"
                    placeholder="End Date"
                    confirm="true"
                    @change="onDateLTEChange"
                  >
                  </date-picker>
                </div>
              </div>

              <md-divider></md-divider>

              <md-subheader class="filter-radio">
                Result
                <md-button
                  class="md-icon-button md-dense"
                  @click="removeFilters('resultStatus')"
                  v-if="resultStatusRadio"
                >
                  <md-icon>clear</md-icon>
                </md-button>
              </md-subheader>
              <md-radio v-model="resultStatusRadio" value="A">Allowed</md-radio>
              <md-radio v-model="resultStatusRadio" value="W">Waiting</md-radio>
              <md-radio v-model="resultStatusRadio" value="D">Denied</md-radio>
              <md-radio v-model="resultStatusRadio" value="FR">Fraud</md-radio>
              <md-radio v-model="resultStatusRadio" value="EX">Timeout</md-radio>
              <md-radio v-model="resultStatusRadio" value="PF">Push Failed</md-radio>
              <md-divider></md-divider>

              <md-subheader class="filter-radio">
                Factor
                <md-button class="md-icon-button md-dense" @click="removeFilters('factor')" v-if="factorRadio">
                  <md-icon>clear</md-icon>
                </md-button>
              </md-subheader>
              <md-radio v-model="factorRadio" value="push">Push</md-radio>
              <md-radio v-model="factorRadio" value="passcode">Passcode </md-radio>
              <md-radio v-model="factorRadio" value="qr_login">QR Login </md-radio>
              <md-radio v-model="factorRadio" value="email">Email</md-radio>
              <md-radio v-model="factorRadio" value="sms">SMS</md-radio>
              <md-radio v-model="factorRadio" value="fido">Fido</md-radio>
            </md-list>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <waiting-for-server
      :show="showWaitingForServerDialog"
      @close="showWaitingForServerDialog = false"
      title="Exporting..."
      button="OK"
      message="We are currently in the process of generating the CSV file related to your query. Once the file is prepared, you will receive a notification in the notification section."
    ></waiting-for-server>

    <more-info
        :show="showMoreInfoDialog"
        :data="selectedAuthTXForMoreInfoDialog"
        @close="showMoreInfoDialog = false"
    ></more-info>
  </div>
</template>

<script>
import * as moment from "moment";
import fetchErrorHandler from "../../error.js";
import { Pagination } from "@/components";
import SearchBox from "../../components/SearchBox";
import WaitingForServer from "@/components/WaitingForServer";
import MoreInfo from "@/components/AuthTX/MoreInfo";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "log-reports",
  components: {
    SearchBox,
    Pagination,
    WaitingForServer,
    MoreInfo,
    DatePicker,
  },
  data: () => ({
    totalLogs: 0,
    removeAll: false,
    filters: {},
    logsPagination: 1,
    totalPages: 1,
    currentSort: "date_created",
    currentSortOrder: "asc",
    logins: [],
    applicationUserRadio: null,
    applicationNameRadio: null,
    deviceIDRadio: null,
    resultStatusRadio: null,
    factorRadio: null,
    dateRadio: null,
    dateCreatedGTE: "",
    dateCreatedLTE: "",
    dateSelectedGTE: "",
    dateSelectedLTE: "",
    search: "",
    usernameSearch: "",
    appNameSearch: "",
    usernameSearched: "",
    appNameSearched: "",
    showWaitingForServerDialog: false,
    selectedAuthTXForMoreInfoDialog: undefined,
    showMoreInfoDialog: false,
  }),
  computed: {
    username: function () {
      return this.filters.application_username;
    },
  },
  methods: {
    fetch_logs: function () {
      let url = this.$store.state.server_address + "api/v1/dashboard/get-logs/";
      let qParam = "";
      if (this.filters) {
        for (let [key, value] of Object.entries(this.filters)) {
          if (qParam === "") {
            qParam += "?";
          } else {
            qParam += "&";
          }
          qParam += key + "=" + value;
        }
        url += qParam;
      }
      let headers = {
        Authorization: this.$store.getters.getAccessToken,
      };
      fetch(url, {
        method: "GET",
        headers: headers,
      })
        .then((log_response) => {
          if (log_response.status !== 200) {
            fetchErrorHandler(log_response.status, log_response.statusText, this.$options.name);
          } else if (this.filters["export"] === "csv") {
            this.showWaitingForServerDialog = true;
          } else
            log_response
              .json()
              .then((log_response) => {
                this.logins = [];
                this.totalPages = log_response.response.total_pages;
                this.totalLogs = log_response.response.total_items;
                for (var i = 0; i < log_response.response.logs.length; i++) {
                  let result = log_response.response.logs[i].human_readable_result;
                  if (result === "allow") {
                    result = "allowed";
                  }
                  if (result === "deny") {
                    result = "denied";
                  }
                  let new_log = {
                    tx_id: log_response.response.logs[i].tx_id,
                    factor: log_response.response.logs[i].factor,
                    payload: log_response.response.logs[i].payload,
                    result: result,
                    username: log_response.response.logs[i].application_username,
                    application_name: log_response.response.logs[i].application_name,
                    date_created: log_response.response.logs[i].date_created,
                    status_flat: log_response.response.logs[i].status_flat,
                    human_readable_status: log_response.response.logs[i].human_readable_status,
                    ipAddress: log_response.response.logs[i].ipaddr,
                    applicationIpAddress: log_response.response.logs[i].application_ipaddr,
                    moreInfo: log_response.response.logs[i].more_info,
                  };
                  this.logins.push(new_log);
                }
              })
              .catch(/* */);
        })
        .catch();
    },
    customSort(value) {
      return value;
    },
    refreshLogs(exportCSV = false) {
      this.filters = Object.assign({}, this.$route.query);
      if (exportCSV === true) {
        this.filters["export"] = "csv";
      }

      this.logsPagination = 1;
      this.fetch_logs();
    },
    formatDate(date) {
      let dateFormated = moment(date).format("MMMM Do YYYY, h:mm:ss a");
      return dateFormated;
    },
    changePage(page) {
      if (this.filters.page !== page) {
        delete this.filters["export"];
        this.filters.page = page;
        this.logins = [];
        this.fetch_logs();
      }
    },
    removeFilters(filter) {
      if (filter === "deviceID") {
        this.deviceIDRadio = null;
        delete this.$route.query.device_id;
      }
      if (filter === "factor") {
        this.factorRadio = null;
        delete this.$route.query.factor;
      }
      if (filter === "date") {
        this.dateRadio = null;
        delete this.$route.query.date_created__gte;
      }
      if (filter === "dateSelectedLTE") {
        this.dateSelectedLTE = "";
        delete this.$route.query.date_created__lte;
      }
      if (filter === "dateSelectedGTE") {
        this.dateSelectedGTE = "";
        delete this.$route.query.date_created__gte;
      }
      if (filter === "user") {
        this.applicationUserRadio = null;
        delete this.$route.query.application_username;
        delete this.$route.query.application_user_pk;
      }
      if (filter === "application") {
        this.applicationNameRadio = null;
        delete this.$route.query.application_id;
        delete this.$route.query.application__name;
      }
      if (filter === "search") {
        this.search = "";
        this.appNameSearched = "";
        this.appNameSearch = "";
        this.usernameSearched = "";
        this.usernameSearch = "";
        delete this.$route.query.application__name__icontains;
        delete this.$route.query.application_username__icontains;
      }
      if (filter === "resultStatus") {
        this.resultStatusRadio = "";
        delete this.$route.query.push_message__status;
        delete this.$route.query.result;
      }
      if (filter === "all" || Object.keys(this.$route.query) == false) {
        this.resultStatusRadio = "";
        this.factorRadio = null;
        this.dateRadio = null;
        this.applicationUserRadio = null;
        this.deviceIDRadio = null;
        this.search = "";
        this.appNameSearched = "";
        this.appNameSearch = "";
        this.usernameSearched = "";
        this.usernameSearch = "";
        this.dateCreatedLTE = "";
        this.dateCreatedGTE = "";
        this.dateSelectedLTE = "";
        this.dateSelectedGTE = "";
        this.dateCreatedGTE = "";
        this.applicationNameRadio = null;
        delete this.$route.query.result;
        delete this.$route.query.factor;
        delete this.$route.query.date_created__gte;
        delete this.$route.query.date_created__lte;
        delete this.$route.query.application_username;
        delete this.$route.query.application_user_pk;
        delete this.$route.query.application__name__icontains;
        delete this.$route.query.application_username__icontains;
        delete this.$route.query.application_id;
        delete this.$route.query.application__name;
        delete this.$route.query.device_id;
        delete this.$route.query.push_message__status;
        delete this.$route.query.result;
        this.removeAll = false;
      }
      this.refreshLogs();
      // window.scrollTo(0, 0);
    },
    doSearch() {
      if (!this.appNameSearch && !this.usernameSearch) {
        this.removeFilters("search");
      }
      if (this.appNameSearch) {
        this.$route.query.application__name__icontains = this.appNameSearch;
        this.appNameSearched = this.appNameSearch;
      }
      if (this.usernameSearch) {
        this.$route.query.application_username__icontains = this.usernameSearch;
        this.usernameSearched = this.usernameSearch;
      }

      this.refreshLogs();
    },
    getRelativeDate(date) {
      return moment(date).fromNow();
    },
    onDateGTEChange() {
      if (this.dateSelectedGTE) {
        if (this.dateSelectedGTE !== this.$route.query.date_created__gte) {
          this.$route.query.date_created__gte = moment(this.dateSelectedGTE).utc().format("YYYY-MM-DDTHH:mm");
          this.refreshLogs();
        }
      }
    },
    onDateLTEChange() {
      if (this.dateSelectedLTE) {
        if (this.dateSelectedLTE !== this.$route.query.date_created__lte) {
          this.$route.query.date_created__lte = moment(this.dateSelectedLTE).utc().format("YYYY-MM-DDTHH:mm");
          this.refreshLogs();
        }
      }
    },
  },
  mounted() {
    this.filters = Object.assign({}, this.$route.query);
    if (this.filters.application_user_pk) {
      this.applicationUserRadio = this.filters.application_username;
    }
    if (this.filters.application__name) {
      this.applicationNameRadio = this.filters.application__name;
    }
    if (this.filters.device_id) {
      this.deviceIDRadio = this.filters.device_id;
    }
    this.refreshLogs();
  },
  updated() {
    if (this.resultRadio) {
      if (this.resultRadio !== this.$route.query.result) {
        this.$route.query.result = this.resultRadio;
        this.refreshLogs();
      }
    }

    if (this.factorRadio) {
      if (this.factorRadio !== this.$route.query.factor) {
        this.$route.query.factor = this.factorRadio;
        this.refreshLogs();
      }
    }
    if (this.dateRadio) {
      let today = new Date();
      let computedDate = null;
      if (this.dateRadio === "day") {
        computedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
      }
      if (this.dateRadio === "week") {
        computedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
      }
      if (this.dateRadio === "month") {
        computedDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
      }
      if (computedDate) {
        this.dateSelectedGTE = "";
        this.dateCreatedGTE = computedDate.toISOString();
      }
      if (this.dateCreatedGTE) {
        if (this.dateCreatedGTE !== this.$route.query.date_created__gte) {
          this.$route.query.date_created__gte = this.dateCreatedGTE;
          this.refreshLogs();
        }
      }
    }

    if (Object.keys(this.$route.query).length) {
      this.removeAll = true;
    } else {
      this.removeAll = false;
    }

    let usernameReg = /username=([^;]+);/;
    let usernameMatches = usernameReg.exec(this.search);
    let appNameReg = /application_name=([^;]+);/;
    let appNameMatches = appNameReg.exec(this.search);
    if (usernameMatches) {
      this.usernameSearch = usernameMatches[1];
    } else if (!appNameMatches) {
      this.usernameSearch = this.search;
    } else {
      this.usernameSearch = "";
    }

    if (appNameMatches) {
      this.appNameSearch = appNameMatches[1];
    } else if (!usernameMatches) {
      this.appNameSearch = this.search;
    } else {
      this.appNameSearch = "";
    }
  },
  watch: {
    resultStatusRadio: function (newValue, oldValue) {
      if (["PF", "EX", "DN", "FR"].includes(newValue)) {
        this.$route.query.push_message__status = newValue;
        delete this.$route.query.result;
        this.refreshLogs();
      } else if (["A", "D", "W"].includes(newValue)) {
        this.$route.query.result = newValue;
        delete this.$route.query.push_message__status;
        this.refreshLogs();
      }
    },
    currentSortOrder: function (newValue, oldValue) {
      if (newValue === "asc") {
        this.filters.order_by = "-date_created";
      } else {
        this.filters.order_by = "date_created";
      }
      this.logins = [];
      this.logsPagination = 1;
      this.fetch_logs();
    },
    dateSelectedLTE: function (newValue, oldValue) {
      if (newValue === null) {
        this.removeFilters("dateSelectedLTE");
      }
    },
    dateSelectedGTE: function (newValue, oldValue) {
      if (newValue === null) {
        this.removeFilters("dateSelectedGTE");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.result-col {
  margin-left: 8px;
}

[class^="flaticon-"]:before,
[class*=" flaticon-"]:before,
[class^="flaticon-"]:after,
[class*=" flaticon-"]:after {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.7);
}

.table-actions {
  padding: 2px;
}

.md-table-narrow-cells .md-table-cell {
  padding: 6px 8px;
}
</style>
<style lang="scss">
.md-table-narrow-cells .md-table-head-label {
  padding-left: 8px;
  padding-right: 4px !important;
}

.md-table-narrow-cells .md-sorted .md-table-head-label {
  padding-left: 24px;
  padding-right: 4px !important;
}
</style>
